import React, { Component } from 'react';
import $, { data } from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import logout from '../login/Logout';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu
class ViewProfile extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
                showPwd: false,
                showCPwd: false,
                showOldPwd: false,
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteStaffDetail(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchStaffDetails()
                this.setState({ disabled: false })
            }
        }];

        const date = new Date();
        var minute = date.getMinutes();
        if (date.getMinutes() > 0 && date.getMinutes() < 10) {
            minute = '0' + date.getMinutes();
        }
        const showCurrentTime = date.getHours()
            + ':' + minute;

        this.state = {
            errors: {},
            showModel: false,
            editable: true,
            error: '',
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            procedureDropDownValue: '',
            physicianId: '',
            selectedDate: new Date(),
            showEditBtn: false,
            patientName: '',
            patientEmailId: '',
            patientContactNumber: '',
            value: [],
            data: [{
                id: '',
                name: '',
                phoneNumber: '',
                emailId: ''
            }],
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            userRoleId: '',
            startTime: showCurrentTime
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
                thisController.fetchHealthSystemDetails();
            } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) {
                thisController.fetchHospitalDetails();
            } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.SERVICELINE_ADMIN) {
                thisController.fetchServiceLineDetails();
            } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.PHYSICIAN) {
                thisController.fetchPhysicianDetails();
            } else {
                thisController.fetchNurseDetails();
            }
        }, 300);


    }
    validateForm = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            errors["oldPassword"] = "*Please enter your old password";
        }

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    changePasswordApi = (e) => {
        if (document.getElementById("oldPassword").value == "") {
            toast.dismiss();
            toast(<b><img src="assets/images/warn.svg"
                style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
                &nbsp;&nbsp;Please enter your old password too.</b>, {
                position: "top-center"
            });
        } else {
            e.preventDefault();
            if (this.validateForm()) {
                let myAccountController = this;
                let errors = {};
                let data = {
                    "emailId": JSON.parse(localStorage.getItem("user_details"))["emailId"],
                    "oldPassword": document.getElementById("oldPassword").value,
                    "newPassword": document.getElementById("newPassword").value
                }
                myAccountController.myFormRef.reset();
                $.ajax({
                    url: "/my-jeeva-api/change-password",
                    type: 'POST',
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json"
                    },
                    
                    data: JSON.stringify(data),
                    success: function (res) {
                        if (res.success === true) {
                            myAccountController.setState({ showStore: false });
                            myAccountController.notifyPasswordChanged();
                            setTimeout(() => {
                                logout();
                            }, 300);

                        } else {
                            myAccountController.setState({ disableOtp: true });
                            errors["response"] = res.result;
                            myAccountController.setState({
                                errors: errors
                            });
                        }
                    }
                });
            }
        }
    }
    fetchHealthSystemDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/fetch-current-health-system-details",
                
                method: 'GET',
                data: {
                    healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        fetchController.state.editable = false;
                        document.getElementById('name').value = responseData.name;
                        document.getElementById('address').value = responseData.address;
                        document.getElementById('phonenumber').value = JSON.parse(localStorage.getItem("user_details"))["mobileNumber"];
                        document.getElementById('website').value = responseData.website;

                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.notifyFailedLoad(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            }
        )

    }


    fetchHospitalDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/fetch-current-hospital-details",
                
                method: 'GET',
                data: {
                    hospitalId: JSON.parse(localStorage.getItem("user_details"))["hospitalId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        fetchController.state.editable = false;
                        document.getElementById('name').value = responseData.name;
                        document.getElementById('address').value = responseData.address;
                        document.getElementById('phonenumber').value = JSON.parse(localStorage.getItem("user_details"))["mobileNumber"];
                        document.getElementById('website').value = responseData.website;

                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.notifyFailedLoad(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            }
        )

    }
    notifyPasswordChanged() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Hurray! Your Password Changed Successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
          position: "top-center",
          color: "red",
        });
      }

    fetchServiceLineDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/fetch-current-service-line-details",
                
                method: 'GET',
                data: {
                    serviceLineId: JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        fetchController.state.editable = false;
                        document.getElementById('serviceline_name').value = responseData.name;
                        document.getElementById('description').value = responseData.description;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.notifyFailedLoad(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            }
        )

    }
    fetchPhysicianDetails() {
        var fetchController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-current-physician-details",
            
            method: 'GET',
            data: {
                userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var responseData = res.result;
                    fetchController.state.editable = false;
                    document.getElementById('user_name').value = responseData.userName;
                    document.getElementById('designation').value = responseData.designation;
                    document.getElementById('contact_number').value = responseData.userPhoneNumber;
                    document.getElementById('email').value = responseData.userEmailId;
                    document.getElementById('comments').value = responseData.comments;
                    fetchController.setState(fetchController.state);
                }
                else {
                    fetchController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }

    fetchNurseDetails() {
        var fetchController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-current-nurse-details",
            
            method: 'GET',
            data: {
                userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var responseData = res.result;
                    fetchController.state.editable = false;
                    document.getElementById('user_name').value = responseData.userName;
                    document.getElementById('designation').value = responseData.designation;
                    document.getElementById('contact_number').value = responseData.userPhoneNumber;
                    document.getElementById('email').value = responseData.userEmailId;
                    document.getElementById('comments').value = responseData.comments;
                    fetchController.setState(fetchController.state);

                }
                else {
                    fetchController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }


    handleChangeName = (e) => {
        this.state.patientEmailId = e.target.value;
        this.setState(this.state);

    }

    handleChangeDescription = (e) => {
        this.state.patientName = e.target.value;
        this.setState(this.state);
    }
    editValue = () => {
        this.state.editable = true;
        this.setState(this.state);
    }
    refreshData = () => {
        var thisController = this;
        if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
            thisController.fetchHealthSystemDetails();
        } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) {
            thisController.fetchHospitalDetails();
        } else {
            thisController.fetchServiceLineDetails();
        }
    }
    showChangePwd = () => {
        this.setState({ showModel: true });
    }
    closeChangePwd = () => {
        this.setState({ showModel: false });
        this.myFormRef.reset();
    }
    validateNewPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateConfirmPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateOldPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            formIsValid = false;
            errors["oldPassword"] = "*Please enter your old password";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    saveProfileUpdatedInfo() {
        //TO DO
    }

    showOldPassword = () => {
        if (this.state.showOldPwd) {
            this.setState({ showOldPwd: false });
        } else {
            this.setState({ showOldPwd: true });
        }
    }

    showPassword = () => {
        if (this.state.showPwd) {
            this.setState({ showPwd: false });
        } else {
            this.setState({ showPwd: true });
        }
    }

    showConfirmPassword = () => {
        if (this.state.showCPwd) {
            this.setState({ showCPwd: false });
        } else {
            this.setState({ showCPwd: true });
        }
    }

    render() {
        return (
            <div id="viewProfile" style={{ height: '530px' }}>
                <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <ToastContainer className="Toast-at-center" />

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h6 className="nav-item" style={{
                                        color: '#282a65',
                                        marginTop: '24px', marginLeft: '1vw'
                                    }}>My Information</h6>
                                </div>
                                {/* Add button and refresh button*/}
                                <div className="col-sm-6" Align='right'>

                                    <button className="btn action-button " style={{ marginLeft: '13px' }}
                                        title={this.state.editable ? "Save" : "Edit"} 
                                        id="addMsg"
                                        onClick={this.state.editable ? this.saveProfileUpdatedInfo : this.editValue}
                                    ><img src={this.state.editable ? this.saveImageSrc : this.editImageSrc} />
                                    </button>
                                    <button onClick={this.refreshData} className="btn action-button" title="Refresh" >
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className="card-body p-0 mb-25" style={{ display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN || window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) ? 'block' : 'none', marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0" style={{ height: '430px' }}>
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                                    <div className="col-sm-12" style={{ marginTop: "10px", marginBottom: '50px' }}>
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Name:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="name" placeholder="Enter Name"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Address:</div>
                                                <input
                                                    type="text" className="col-sm-8"
                                                    name="address" id="address" placeholder="Enter Address"
                                                    //value={this.state.fields.description}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>


                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Mobile Number:</div>
                                                <input className="col-sm-8"
                                                    type="text" id="phonenumber"
                                                    name="phonenumber" placeholder="Enter Mobile Number"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Website:</div>
                                                <input
                                                    type="text" id="website" className="col-sm-8"
                                                    name="website" placeholder="Enter Website"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.supportPhoneNumber}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row' style={{ height: '5vw' }}>
                                        <div className='col-sm-12'>
                                            <button type="button" className="btn btn-primary"
                                                style={{ width: "150px", fontSize: '14px' }} onClick={this.showChangePwd}>Change Password</button>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0 mb-25" style={{ display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.SERVICELINE_ADMIN) ? 'block' : 'none', marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">

                                    <div className="col-sm-12" style={{ marginTop: "10px", marginBottom: '50px' }}>
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Name:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="serviceline_name" placeholder="Enter Name"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Description</div>
                                                <input className="col-sm-8"
                                                    type="text" id="description"
                                                    name="description" placeholder="Enter Description"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className='row' style={{ height: '5vw' }}>
                                        <div className='col-sm-6'>
                                            <button type="button" className="btn btn-primary"
                                                style={{ width: "150px", fontSize: '14px' }} onClick={this.showChangePwd}>Change Password</button>

                                        </div>
                                        <div className='col-sm-6'>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0 mb-25" style={{ display: ((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.PHYSICIAN) || (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.NURSE)) ? 'block' : 'none', marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">

                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Name:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="user_name" placeholder="Enter Name"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Designation:</div>
                                                <input className="col-sm-8"
                                                    type="text" id="designation"
                                                    name="designation" placeholder="Enter Designation"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Contact Number:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="contact_number" placeholder="Enter Contact Number"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Email:</div>
                                                <input className="col-sm-8"
                                                    type="text" id="email"
                                                    name="email" placeholder="Enter Email"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Comments:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="comments" placeholder="Enter Comments"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2',
                                                        overflowY: 'scroll'
                                                    }} />
                                            </div>
                                        </div>


                                    </div>
                                    <div className='row' style={{ height: '5vw' }}>
                                        <div className='col-sm-12'>
                                            <button type="button" className="btn btn-primary"
                                                style={{ width: "150px", fontSize: '16px', marginTop: '1vw' }} onClick={this.showChangePwd}>Change Password</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="modal" style={{ display: this.state.showModel ? 'block' : 'none' }}>
                            <div className="modal-dialog" id="center-aligned-password-modal">
                                <div className="modal-content" style={{ height: "auto", width: "830px" }}>
                                    <div className="modal-header noBorder" style={{ height: '39px' }}>
                                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeChangePwd}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={(el) => this.myFormRef = el}>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Old Password</label>
                                                <div className="col-sm-8">
                                                    <input type={this.state.showOldPwd ? "text" : "password"} className="form-control-plaintext" onBlur={this.validateOldPwd}
                                                        name="oldPassword" id="oldPassword" onChange={this.handleChange} />
                                                    <div className="input-group-append">
                                                        <button className="btn showPassbtn" type="button"
                                                            onClick={this.showOldPassword}>{this.state.showOldPwd ? 'Hide' : 'Show'}</button>
                                                    </div>

                                                </div>
                                                <div>
                                                    <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.oldPassword}</span>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">New Password</label>
                                                <div className="col-sm-8">
                                                    <input type={this.state.showPwd ? "text" : "password"} className="form-control-plaintext" onBlur={this.validateNewPwd}
                                                        name="newPassword" id="newPassword" onChange={this.handleChange} />
                                                    <div className="input-group-append">
                                                        <button className="btn showPassbtn" type="button"
                                                            onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                                    </div>
                                                    <span className="pNote">Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                    <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword} </span>
                                            </div> <br />
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Confirm Password</label>
                                                <div className="col-sm-8">
                                                    <input type={this.state.showCPwd ? "text" : "password"} className="form-control-plaintext" onBlur={this.validateConfirmPwd}
                                                        name="confirmPassword" id="confirmPassword" onChange={this.handleChange} />
                                                    <div className="input-group-append">
                                                        <button className="btn showPassbtn" type="button"
                                                            onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                                                    </div>
                                                    <span className="pNote">Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                    <div className="errorMsg" style={{ color: 'red', marginTop: "-6.5rem" }}>{this.state.errors.confirmPassword}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.confirmPassword}</span>
                                            </div> <br />
                                            <div className="modal-footer noBorder">
                                                <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.changePasswordApi}>Done</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* <DialogComponent width='400px' style={{}} animationSettings={this.settings}
                        header='Basic App Details' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog} target='#viewProfile'
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete basic app details?<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent> */}

                </div>

            </div>

        );
    }
}
export default ViewProfile;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewProfile.js